module.exports = __webpack_public_path__ + "img/img_prize_detail1.ff6da7df.png";